var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.componentClasses,attrs:{"type":_vm.submitType},on:{"click":function($event){return _vm.clicked()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }